
// import React from "react";
// import { ClipboardIcon } from "@heroicons/react/24/outline"; 
// import { FiChevronRight } from "react-icons/fi";

// const CodeBlock = ({ code }) => {
//   const [copied, setCopied] = React.useState(false);

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(code);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   return (
//     <div className="relative bg-black/90 rounded-lg overflow-hidden mb-4">
//       <div className="absolute top-2 right-2 z-10">
//         <button
//           onClick={copyToClipboard}
//           className="p-1.5 rounded text-white"
//           title="Copy to clipboard"
//         >
//           {copied ? (
//             <span className="text-green-400 text-lg leading-none">✔</span>
//           ) : (
//             <ClipboardIcon className="w-4 h-4" />
//           )}
//         </button>
//       </div>

//       <pre className="text-xs text-green-400 p-4 pt-8 font-mono overflow-x-auto">
//         {code}
//       </pre>
//     </div>
//   );
// };

// export function renderOracleExporterSetup () {
//     return (
//       <div>
//         <main className="transition-opacity duration-300">
//           <div className="py-3">
//             {/* Breadcrumbs */}
//             <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
//           <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
//           <FiChevronRight />
//           <span>Agent Setup Guide</span>
//           <FiChevronRight />
//           <span>Database</span>
//           <FiChevronRight />
//           <span className="text-[#1b140d] dark:text-white font-medium">Oracle</span>
//         </nav>
    
//             {/* Intro */}
//             <div className="mb-10 scroll-mt-24" id="introduction">
//               <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
//                 Documentation
//               </span>
//               <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
//                 <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
//                   NETRAA Sentinel & Oracle Exporter
//                 </span> Setup Guide
//               </h1>
//               <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
//                 This package installs and manages ORACLE monitoring on your server using Netraa Oracle Sentinel and Agent.
//               </p>
//             </div>
    
//             {/* Deployment Summary Cards */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
//               {[
//                 { title: "Deployment Environment", value: "On-Prem / Server" },
//                 { title: "Supported OS", value: "RHEL / Oracle Linux / Ubuntu" },
//                 { title: "Required Access", value: "Root / Sudo" },
//               ].map((item, idx) => (
//                 <div key={idx} className="bg-surface-light dark:bg-surface-dark p-4 rounded-xl border border-border-color dark:border-border-dark shadow-sm">
//                   <p className="text-[10px] uppercase font-bold text-text-muted mb-1">{item.title}</p>
//                   <p className={`text-sm font-bold ${idx === 0 ? "text-primary" : "text-text-main dark:text-white"}`}>{item.value}</p>
//                 </div>
//               ))}
//             </div> 
    
//             {/* Important Note */}
//             <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 p-4 mb-12 rounded-r-lg">
//               <div className="flex items-center gap-2 mb-1">
//                 <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-sm">warning</span>
//                 <h4 className="text-sm font-bold text-amber-800 dark:text-amber-300">IMPORTANT NOTE</h4>
//               </div>
//               <p className="text-xs text-amber-700 dark:text-amber-400 leading-relaxed">
//                 Ensure you have the necessary Oracle credentials and host access before starting the installation. Root or sudo privileges are required.
//               </p>
//             </div>
    
//     <div className="mb-10">
//               <h4 className="text-2xl lg:text-2xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
//                   NETRAA Oracle Sentinel Setup Guide
//               </h4>
//               <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
//                 This package installs and manages ORACLE Monitoring on your server using NETRAA Sentinel.
//               </p>
//             </div>
    
//             {/* Prerequisites */}
//             <section className="mb-10 scroll-mt-24" id="prerequisites">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//                 <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
//                   <span className="material-symbols-outlined text-[24px]">fact_check</span>
//                 </span>
//                 Prerequisites
//               </h2>
    
//               <div className="prose dark:prose-invert max-w-none text-sm space-y-2 mb-8">
//                 <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400">
//                   <li>Docker</li>
//                   <li>Docker Compose</li>
//                 </ul>
//               </div>
//             </section>
    
//             {/* Step 1: Download & Navigate */}
//             <section className="mb-10 scroll-mt-24" id="step-1">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 1: Download NETRAA Sentinel</h2>
//               <p className="text-sm text-text-muted mb-2">
//                 Download <code className="font-mono">NETRAA_SENTINEL.zip</code> from the ApMoSys share and unzip it:
//               </p>
//               <CodeBlock code={`unzip NETRAA_SENTINEL.zip
//     cd NETRAA_SENTINEL
//     # ⚠ Make sure you are inside the correct folder before proceeding`} />
//             </section>
    
//             {/* Step 2: Load Docker Image */}
//             <section className="mb-10 scroll-mt-24" id="step-2">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 2: Load the Sentinel Docker Image</h2>
//               <p className="text-sm text-text-muted mb-2">
//                 If the image file is provided inside the package, load it:
//               </p>
//               <CodeBlock code={`docker load -i netraa-sentinel-V1.0.0.tar
//     docker images | grep netraa/sentinel:1.0.0`} />
//             </section>
    
//             {/* Step 3: Configure Elasticsearch */}
//             <section className="mb-10 scroll-mt-24" id="step-3">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 3: Configure Elasticsearch Endpoint</h2>
//               <p className="text-sm text-text-muted mb-2">
//                 Open <code className="font-mono">docker-compose.yml</code> and update:
//               </p>
//               <CodeBlock code={`ELASTIC_HOST: <HOST_IP where the elastic is running>
//     ELASTIC_PORT: 9200
    
//     # If authentication is enabled:
//     ELASTIC_USERNAME:
//     ELASTIC_PASSWORD:
//     # If authentication is NOT enabled, leave username and password blank.`} />
//             </section>
    
//             {/* Step 4: Start Sentinel */}
//             <section className="mb-10 scroll-mt-24" id="step-4">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 4: Start Sentinel</h2>
//               <CodeBlock code={`docker-compose up -d`} />
//             </section>
    
//             {/* Step 5: Verify */}
//             <section className="mb-10 scroll-mt-24" id="step-5">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 5: Verify Application</h2>
//               <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400 text-sm">
//                 <li>Check container status: <code className="font-mono">docker ps</code></li>
//                 <li>View logs if needed: <code className="font-mono">docker logs -f sentinel</code></li>
//               </ul>
//             </section>
    
//             {/* Troubleshooting */}
//             <section className="mb-10 scroll-mt-24" id="troubleshooting">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Troubleshooting</h2>
//               <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400 text-sm">
//                 <li>Stop Sentinel: <code className="font-mono">docker-compose down</code></li>
//                 <li>Ensure Elasticsearch is reachable: <code className="font-mono">curl http://192.168.12.95:9200</code></li>
//                 <li>If authentication is enabled: <code className="font-mono">curl -u elastic:password http://192.168.12.95:9200</code></li>
//                 <li>Verify no firewall is blocking port <code className="font-mono">9200</code>.</li>
//               </ul>
//             </section>
            
//             <div className="mb-10 scroll-mt-24" id="download-agent">
//               <h4 className="text-2xl lg:text-2xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
//                   NETRAA Oracle Agent Setup Guide
//               </h4>
//               <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
//                 This package installs and manages ORACLE Monitoring on your server using NETRAA oracle Agent.
//               </p>
//             </div>
//             {/* Step 1: Download the Agent */}
//             <section className="mb-10">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//                 <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
//                   <span className="material-symbols-outlined text-[24px]">download</span>
//                 </span>
//                 1. Download the Agent
//               </h2>
//               <p className="text-sm text-text-muted mb-4">
//                 Download the Oracle agent file from the ApMoSys SharePoint and unzip it using the following command:
//               </p>
//               <CodeBlock code={`unzip oracle_agent.zip -d oracle_agent\ncd oracle_agent`} />
//             </section>
    
//             {/* Step 2: Run Installer */}
//             <section className="mb-10 scroll-mt-24" id="run-installer">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//                 <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-green-100 dark:bg-green-900/30 text-green-600 border border-green-200 dark:border-green-900/50">
//                   <span className="material-symbols-outlined text-[24px]">play_circle</span>
//                 </span>
//                 2. Run the Installer
//               </h2>
//               <p className="text-sm text-text-muted mb-4">
//                 Execute the following command to install the agent:
//               </p>
//               <CodeBlock code={`sudo ./install.sh`} />
//             </section>
    
//             {/* Step 3: Update Required Details */}
//             <section className="mb-16 scroll-mt-24" id="update-details">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//                 <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-orange-600 border border-orange-200 dark:border-orange-900/50">
//                   <span className="material-symbols-outlined text-[24px]">edit_note</span>
//                 </span>
//                 3. Update Required Details
//               </h2>
//               <div className="prose dark:prose-invert max-w-none text-sm space-y-2">
//                 <p>During installation, you will see prompts like:</p>
//                 <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400">
//                   <li><strong>Uninstall Option:</strong> Do you want to uninstall instead? (y/N)</li>
//                   <li><strong>Oracle root username and password</strong></li>
//                   <li><strong>Host and port details of Oracle</strong></li>
//                   <li><strong>User details:</strong> username and password (the script will create a user if it does not exist)</li>
//                   <li><strong>Host name:</strong> Service name visible in the dashboard</li>
//                   <li><strong>Service instance ID confirmation:</strong> Use default service_instance_id (localhost:1521)? (Y/n)</li>
//                 </ul>
//                 <p>Choose <code>n</code> if you want a different instance ID and enter the required value.</p>
//               </div>
//             </section>
    
//             {/* Optional Table Example */}
//             <section className="mb-16 scroll-mt-24" id="env-specs">
//               <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//                 <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-100 dark:bg-purple-900/30 text-purple-600 border border-purple-200 dark:border-purple-900/50">
//                   <span className="material-symbols-outlined text-[24px]">grid_view</span>
//                 </span>
//                 Environment Specification Table
//               </h2>
//               <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
//                 <table className="w-full text-left border-collapse">
//                   <thead className="divide-y divide-border-color dark:divide-border-dark text-[11px]">
//                     <tr>
//                       <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Step</th>
//                       <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Action</th>
//                       <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Command / Note</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-border-color dark:divide-border-dark text-[11px]">
//                     <tr>
//                       <td className="px-3 py-2 font-bold text-primary">1</td>
//                       <td className="px-3 py-2">Download Agent</td>
//                       <td className="px-3 py-2"><code>unzip oracle_agent.zip -d oracle_agent</code></td>
//                     </tr>
//                     <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
//                       <td className="px-3 py-2 font-bold text-primary">2</td>
//                       <td className="px-3 py-2">Run Installer</td>
//                       <td className="px-3 py-2"><code>sudo ./install.sh</code></td>
//                     </tr>
//                     <tr>
//                       <td className="px-3 py-2 font-bold text-primary">3</td>
//                       <td className="px-3 py-2">Update Details</td>
//                       <td className="px-3 py-2">Follow prompts to configure Oracle root, users, host, port, and instance ID.</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </section>
//           </div>
//         </main>
//       </div>
//     );
//     }


import React from "react";
import { ClipboardIcon } from "@heroicons/react/24/outline"; 
import { FiChevronRight } from "react-icons/fi";
import oracleImg from "../../assets/Oracle.png";

const CodeBlock = ({ code }) => {
  const [copied, setCopied] = React.useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="relative bg-black/90 rounded-lg overflow-hidden mb-4">
      <div className="absolute top-2 right-2 z-10">
        <button
          onClick={copyToClipboard}
          className="p-1.5 rounded text-white"
          title="Copy to clipboard"
        >
          {copied ? (
            <span className="text-green-400 text-lg leading-none">✔</span>
          ) : (
            <ClipboardIcon className="w-4 h-4" />
          )}
        </button>
      </div>

      <pre className="text-xs text-green-400 p-4 pt-8 font-mono overflow-x-auto">
        {code}
      </pre>
    </div>
  );
};

export function renderOracleExporterSetup () {
    return (
      <div>
        <main className="transition-opacity duration-300">
          <div className="py-3">
            {/* Breadcrumbs */}
            <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
          <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
          <FiChevronRight />
          <span>Agent Setup Guide</span>
          <FiChevronRight />
          <span>Database</span>
          <FiChevronRight />
          <span className="text-[#1b140d] dark:text-white font-medium">Oracle</span>
        </nav>
    
            {/* Intro */}
            <div className="mb-10 scroll-mt-24" id="introduction">
              <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
                Documentation
              </span>
              <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
                  NETRAA Sentinel & Oracle Exporter
                </span> Setup Guide
              </h1>
              <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
                This package installs and manages ORACLE monitoring on your server using Netraa Oracle Sentinel and Agent.
              </p>
            </div>
    
            {/* Deployment Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              {[
                { title: "Deployment Environment", value: "On-Prem / Server" },
                { title: "Supported OS", value: "RHEL / Oracle Linux / Ubuntu" },
                { title: "Required Access", value: "Root / Sudo" },
              ].map((item, idx) => (
                <div key={idx} className="bg-surface-light dark:bg-surface-dark p-4 rounded-xl border border-border-color dark:border-border-dark shadow-sm">
                  <p className="text-[10px] uppercase font-bold text-text-muted mb-1">{item.title}</p>
                  <p className={`text-sm font-bold ${idx === 0 ? "text-primary" : "text-text-main dark:text-white"}`}>{item.value}</p>
                </div>
              ))}
            </div> 
    
            {/* Important Note */}
            <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 p-4 mb-12 rounded-r-lg">
              <div className="flex items-center gap-2 mb-1">
                <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-sm">warning</span>
                <h4 className="text-sm font-bold text-amber-800 dark:text-amber-300">IMPORTANT NOTE</h4>
              </div>
              <p className="text-xs text-amber-700 dark:text-amber-400 leading-relaxed">
                Ensure you have the necessary Oracle credentials and host access before starting the installation. Root or sudo privileges are required.
              </p>
            </div>
    
    <div className="mb-10">
              <h4 className="text-2xl lg:text-2xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
                  NETRAA Oracle Sentinel Setup Guide
              </h4>
              <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
                This package installs and manages ORACLE Monitoring on your server using NETRAA Sentinel.
              </p>
            </div>
    
            {/* Prerequisites */}
            <section className="mb-10 scroll-mt-24" id="prerequisites">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
                  <span className="material-symbols-outlined text-[24px]">fact_check</span>
                </span>
                Prerequisites
              </h2>
    
              <div className="prose dark:prose-invert max-w-none text-sm space-y-2 mb-8">
                <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400">
                  <li>Docker</li>
                  <li>Docker Compose</li>
                  <li>Enable the port 4444 in the AOP server.</li>
                  <li>A database user with the following access:</li>
                </ul>
                <CodeBlock code={`-- Create a new user for monitoring
CREATE USER monitor_user IDENTIFIED BY <username>
DEFAULT TABLESPACE USERS
TEMPORARY TABLESPACE TEMP
QUOTA UNLIMITED ON USERS;
-- Grant minimal privileges to connect
GRANT CREATE SESSION TO <username>;
-- Allow reading system metrics
GRANT SELECT ANY DICTIONARY TO <username>;
-- Specific v$ views commonly used for monitoring
GRANT SELECT ON V_$SESSION TO <username>;
GRANT SELECT ON V_$SQL TO <username>;
GRANT SELECT ON V_$SYSSTAT TO <username>;
GRANT SELECT ON V_$PROCESS TO <username>;`} />
              </div>
            </section>
    
            {/* Step 1: Download & Navigate */}
            <section className="mb-10 scroll-mt-24" id="step-1">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 1: Download NETRAA Sentinel</h2>
              <p className="text-sm text-text-muted mb-2">
                Download <code className="font-mono">NETRAA_SENTINEL.zip</code> from the ApMoSys share in the AOP server and unzip it:
              </p>
              <CodeBlock code={`unzip NETRAA_SENTINEL.zip
cd NETRAA_SENTINEL
# ⚠ Make sure you are inside the correct folder before proceeding`} />
            </section>
    
            {/* Step 2: Load Docker Image */}
            <section className="mb-10 scroll-mt-24" id="step-2">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 2: Load the Sentinel Docker Image</h2>
              <p className="text-sm text-text-muted mb-2">
                Load the Sentinel Docker image:
              </p>
              <CodeBlock code={`docker load -i netraa-sentinel-V1.0.0.tar`} />
              <p className="text-sm text-text-muted mb-2">
                Validate whether the image is loaded or not:
              </p>
              <CodeBlock code={`docker images | grep netraa/sentinel:1.0.0`} />
            </section>
    
            {/* Step 3: Configure Elasticsearch */}
            <section className="mb-10 scroll-mt-24" id="step-3">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 3: Configure Elasticsearch Endpoint</h2>
              <p className="text-sm text-text-muted mb-2">
                Open <code className="font-mono">docker-compose.yml</code> and update:
              </p>
              <CodeBlock code={`ELASTIC_HOST: <HOST_IP where the elastic is running>
ELASTIC_PORT: 9200

# If authentication is enabled:
ELASTIC_USERNAME:
ELASTIC_PASSWORD:
# If authentication is NOT enabled, leave username and password blank.`} />
            </section>
    
            {/* Step 4: Start Sentinel */}
            <section className="mb-10 scroll-mt-24" id="step-4">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 4: Start Sentinel</h2>
              <CodeBlock code={`docker-compose up -d`} />
            </section>
    
            {/* Step 5: Verify */}
            <section className="mb-10 scroll-mt-24" id="step-5">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 5: Verify Application</h2>
              <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400 text-sm">
                <li>Check container status: <code className="font-mono">docker ps</code></li>
                <li>View logs if needed: <code className="font-mono">docker logs -f sentinel</code></li>
              </ul>
            </section>
    
            {/* Troubleshooting */}
            <section className="mb-10 scroll-mt-24" id="troubleshooting">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Troubleshooting</h2>
              <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400 text-sm">
                <li>Stop Sentinel: <code className="font-mono">docker-compose down</code></li>
                <li>Ensure Elasticsearch is reachable: <code className="font-mono">curl http://192.168.12.95:9200</code></li>
                <li>If authentication is enabled: <code className="font-mono">curl -u elastic:password http://192.168.12.95:9200</code></li>
                <li>Verify no firewall is blocking port <code className="font-mono">9200</code>.</li>
              </ul>
            </section>

            {/* Plugin Setup */}
            <section className="mb-10 scroll-mt-24" id="plugin-setup">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Plugin Setup</h2>

              <section className="mb-10 scroll-mt-24" id="plugin-step-1">
                <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 1: Download the Plugin</h2>
                <p className="text-sm text-text-muted mb-2">
                  Download the Oracle-Plugin in the AOP server from the provided ApMoSys SharePoint and unzip it using the following command:
                </p>
                <CodeBlock code={`unzip Oracle-Plugin`} />
              </section>

              <section className="mb-10 scroll-mt-24" id="plugin-step-2">
                <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 2: Configuration</h2>
                <p className="text-sm text-text-muted mb-2">
                  Open the <code className="font-mono">Oracle-agent-deployment</code> file and edit the <code className="font-mono">config.json</code> file with the required details.
                </p>
              </section>

              <section className="mb-10 scroll-mt-24" id="plugin-step-3">
                <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">Step 3: Run</h2>
                <p className="text-sm text-text-muted mb-2">
                  Now run the <code className="font-mono">Install.sh</code> file.
                </p>
  <img
  src={oracleImg}
  alt="Oracle setup step"
  className="mt-4 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
/>        </section>
            </section>
            
            <div className="mb-10 scroll-mt-24" id="download-agent">
              <h4 className="text-2xl lg:text-2xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
                  NETRAA Oracle Agent Setup Guide
              </h4>
              <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
                This package installs and manages ORACLE Monitoring on your server using NETRAA oracle Agent.
              </p>
            </div>
            {/* Step 1: Download the Agent */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
                  <span className="material-symbols-outlined text-[24px]">download</span>
                </span>
                1. Download the Agent
              </h2>
              <p className="text-sm text-text-muted mb-4">
                Download the Oracle agent file from the ApMoSys SharePoint and unzip it using the following command:
              </p>
              <CodeBlock code={`unzip oracle_agent.zip -d oracle_agent\ncd oracle_agent`} />
            </section>
    
            {/* Step 2: Run Installer */}
            <section className="mb-10 scroll-mt-24" id="run-installer">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-green-100 dark:bg-green-900/30 text-green-600 border border-green-200 dark:border-green-900/50">
                  <span className="material-symbols-outlined text-[24px]">play_circle</span>
                </span>
                2. Run the Installer
              </h2>
              <p className="text-sm text-text-muted mb-4">
                Execute the following command to install the agent:
              </p>
              <CodeBlock code={`sudo ./install.sh`} />
            </section>
    
            {/* Step 3: Update Required Details */}
            <section className="mb-16 scroll-mt-24" id="update-details">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-orange-600 border border-orange-200 dark:border-orange-900/50">
                  <span className="material-symbols-outlined text-[24px]">edit_note</span>
                </span>
                3. Update Required Details
              </h2>
              <div className="prose dark:prose-invert max-w-none text-sm space-y-2">
                <p>During installation, you will see prompts like:</p>
                <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400">
                  <li><strong>Uninstall Option:</strong> Do you want to uninstall instead? (y/N)</li>
                  <li><strong>Oracle root username and password</strong></li>
                  <li><strong>Host and port details of Oracle</strong></li>
                  <li><strong>User details:</strong> username and password (the script will create a user if it does not exist)</li>
                  <li><strong>Host name:</strong> Service name visible in the dashboard</li>
                  <li><strong>Service instance ID confirmation:</strong> Use default service_instance_id (localhost:1521)? (Y/n)</li>
                </ul>
                <p>Choose <code>n</code> if you want a different instance ID and enter the required value.</p>
              </div>
            </section>
    
            {/* Optional Table Example */}
            <section className="mb-16 scroll-mt-24" id="env-specs">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-100 dark:bg-purple-900/30 text-purple-600 border border-purple-200 dark:border-purple-900/50">
                  <span className="material-symbols-outlined text-[24px]">grid_view</span>
                </span>
                Environment Specification Table
              </h2>
              <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
                <table className="w-full text-left border-collapse">
                  <thead className="divide-y divide-border-color dark:divide-border-dark text-[11px]">
                    <tr>
                      <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Step</th>
                      <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Action</th>
                      <th className="px-3 py-2 font-bold text-text-muted text-[10px] uppercase">Command / Note</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border-color dark:divide-border-dark text-[11px]">
                    <tr>
                      <td className="px-3 py-2 font-bold text-primary">1</td>
                      <td className="px-3 py-2">Download Agent</td>
                      <td className="px-3 py-2"><code>unzip oracle_agent.zip -d oracle_agent</code></td>
                    </tr>
                    <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
                      <td className="px-3 py-2 font-bold text-primary">2</td>
                      <td className="px-3 py-2">Run Installer</td>
                      <td className="px-3 py-2"><code>sudo ./install.sh</code></td>
                    </tr>
                    <tr>
                      <td className="px-3 py-2 font-bold text-primary">3</td>
                      <td className="px-3 py-2">Update Details</td>
                      <td className="px-3 py-2">Follow prompts to configure Oracle root, users, host, port, and instance ID.</td>
                    </tr>￼
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </main>
      </div>
    );
    }